import React from 'react';
import propTypes from 'prop-types';
import { translate } from '@fiverr-private/i18n-react';
import * as I18n from '../../lib/hoc';
import './style.scss';
import { TYPES, normalizeDrawerType } from '../../NotificationsDrawer/types';

function EmptyState({ drawerType }) {
    const normalizedType = normalizeDrawerType(drawerType);
    switch (normalizedType) {
        case TYPES.BOTH:
        case TYPES.NOTIFICATIONS:
            return (
                <div className="drawer-empty notifications">
                    <strong>
                        {translate('realtime_notifications.notifications_drawer.notifications_tab.no_notifications')}
                    </strong>
                    <p>
                        {translate(
                            'realtime_notifications.notifications_drawer.notifications_tab.no_notifications_sub'
                        )}
                    </p>
                </div>
            );
        case TYPES.MESSAGES:
            return (
                <div className="drawer-empty messages">
                    <strong>{translate('realtime_notifications.notifications_drawer.messages_tab.no_messages')}</strong>
                    <p>{translate('realtime_notifications.notifications_drawer.messages_tab.no_messages_sub')}</p>
                </div>
            );
        default:
            return null;
    }
}

EmptyState.propTypes = {
    drawerType: propTypes.string,
};

export default I18n.connect(EmptyState);
